// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Create = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M20,20.43a.5.5,0,0,1-.24-.06l-6.93-3.85a.5.5,0,0,1-.26-.44V8.35a.5.5,0,0,1,.26-.44L19.8,4.06a.5.5,0,0,1,.49,0l6.84,3.85a.5.5,0,0,1,.25.44v7.73a.5.5,0,0,1-.25.44l-6.84,3.85A.5.5,0,0,1,20,20.43Zm-6.43-4.64L20,19.36l6.34-3.57V8.64L20,5.07,13.61,8.64Z" />
            <Path d="M11.44,36a.5.5,0,0,1-.24-.06L4.26,32.09A.5.5,0,0,1,4,31.65V23.92a.5.5,0,0,1,.26-.44l6.94-3.85a.5.5,0,0,1,.49,0l6.84,3.85a.5.5,0,0,1,.25.44v7.73a.5.5,0,0,1-.25.44l-6.84,3.85A.5.5,0,0,1,11.44,36ZM5,31.36l6.43,3.57,6.34-3.57V24.21l-6.34-3.57L5,24.21Z" />
            <Path d="M28.66,36a.5.5,0,0,1-.24-.06l-6.94-3.85a.5.5,0,0,1-.26-.44V23.92a.5.5,0,0,1,.26-.44l6.94-3.85a.5.5,0,0,1,.49,0l6.84,3.85a.5.5,0,0,1,.25.44v7.73a.5.5,0,0,1-.25.44L28.9,35.94A.5.5,0,0,1,28.66,36Zm-6.44-4.64,6.43,3.57L35,31.36V24.21l-6.34-3.57-6.43,3.57Z" />
        </G>
    );
};

export default Create;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/create/index.js